import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.svg";
import Avtar from "../../assets/images/av.png";
import useDialogBox from "../../hooks/useDialogBox";
import { isLoggedIn, capitalizeFirstLetter } from "../../utils";

export default function Header() {
  // custom Hook for status update Popup
  const [setOpen, DialogJSX] = useDialogBox();

  const history = useNavigate();
  const [user, setUser] = useState({});
  const Logout = (e) => {
    e.preventDefault();
    localStorage.clear();
    history("/");
  };

  useEffect(() => {
    setUser(isLoggedIn());
  }, []);

  return (
    <React.Fragment>
      <div className="Header">
        <div className="Logo">
          <img src={Logo} />
        </div>
        <div className="Navigation">
          <div className="Avater">
            <a>
              <figure>
                <img src={Avtar} />
              </figure>
              {capitalizeFirstLetter(user.name)}
            </a>
            <ul>
              <li>
                <figure>
                  <img src={Avtar} />
                </figure>
                <h4>
                  {capitalizeFirstLetter(user.name)} <br></br>
                  <span>Administrator</span>
                </h4>
              </li>
              {/* <li>
                <Link to="/profile">
                  <span>
                    <i className="fa fa-cog"></i>
                  </span>
                  My Profile
                </Link>
              </li> */}
              <li>
                <Link to="/change-password">
                  <span>
                    <i className="fa fa-cog"></i>
                  </span>
                  Change Settings
                </Link>
              </li>
              <li>
                <a onClick={()=>setOpen(true)}>
                  <span>
                    <i className="fa fa-sign-out"></i>
                  </span>
                  Logout
                </a>
              </li>
            </ul>
          </div>
          <div className="clear"></div>
        </div>
      </div>
       {/* Add DialogBox for Update status popUp */}
       <DialogJSX
        title="Logout"
        bodyTitle="Are you sure want to Logout?"
        final={Logout}
      />
    </React.Fragment>
  );
}
